<template>
    <div id="materExchange">
        <el-form ref="searchForm" :model="searchForm" style="width:100%" :inline="true" :label-position="labelPosition">
            <el-form-item style="margin-bottom:15px">
                <el-input clearable @change="inputSearch" v-model.trim="searchForm.exchangeIndex" placeholder="请输入序列号"></el-input>
            </el-form-item>
            <el-form-item style="margin-bottom: 15px;">
                <el-button type="primary" size="medium" @click="SubmitSearch('searchForm')">查询</el-button>
                <el-button type="text" @click="clearFrom()" style="width: 60px;color: #169BD5;">重置</el-button>
            </el-form-item>
            <el-form-item class="fr">
                <el-col style="text-align:right">
                    <el-button type="success" size="medium" @click="downLoad.exportExcel('tableId')">导出</el-button>
                    <i class="el-icon-refresh" style="font-size: 25px;cursor: pointer;margin-left: 30px;" @click="refresh()"></i>
                </el-col>
            </el-form-item>
        </el-form>
        <el-col>
            <el-table
                :data="returnData"
                border
                id="tableId"
                :header-cell-style="{'text-align':'center'}"
                style="width: 100%">
                <el-table-column
                    align="center"
                    prop="code"
                    width="300"
                    label="流转序号">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="relatedType"
                    width="100"
                    label="流转类型">
                    <template slot-scope="scope">
                        {{ scope.row.relatedType | sysCodeFileter('related_type')}}                        
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="operatorTime"
                    width="200"
                    label="流转时间">
                </el-table-column> 
                <el-table-column
                    align="center"
                    prop="operator"
                    label="操作人">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="belongDeptId"
                    width="150"
                    label="归属门店">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="belonger"
                    width="200"
                    label="仓库/工程师">
                </el-table-column>
                <el-table-column
                    align="center"  
                    prop="relatedCode"
                    width="150"
                    label="单据编号">
                </el-table-column>
            </el-table>
            <!--分页-->
            <el-col :span="24" class="toolbar">
                <div class="pagination">
                    <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pages.page"
                        :page-sizes="[10, 20, 50, 100,500,1000,10000]"
                        :page-size="pages.pageSize"
                        layout="total, sizes, prev, pager, next,jumper"
                        :total="pages.total">
                    </el-pagination>
                </div>
            </el-col>
        </el-col>
    </div>
</template>

<script>
    import {
        suppliesFlowList
    } from "../../api/api";
    export default {
        inject:['reload'],
        name: 'materExchange',
        data () {
            const validateNumber = (rule, value, callback) => {
                if (/^[1-9]\d*|0$/.test(value) == false) {
                    callback(new Error("请输入一个大于0的整数"));
                }else {
                    callback();
                }
            }
            return {
                searchForm:{
                    exchangeIndex:'',
                },
                returnData: [],
                labelPosition:'left',
                //分页变量
                pages:{
                    total: 0,
                    page: 1,
                    pageSize: 10,
                },
            }
        },
        components: {
        },
        mounted () {
          
        },
        created(){
            this.suppliesFlowList()
        },
        methods: {
            clearFrom(){
                this.searchForm.exchangeIndex = "";
                this.suppliesFlowList();
            },
            inputSearch(){
                this.suppliesFlowList()
            },
            handleSizeChange(val) {
                this.pages.pageSize = val
                this.suppliesFlowList()
            },
            handleCurrentChange(Page) {
                this.pages.page = Page
                this.suppliesFlowList()
            },
            //物料流转记录查询
            suppliesFlowList(){
                let para={
                    code:this.searchForm.exchangeIndex,
                    startRow:this.pages.page,
                    pageSize:this.pages.pageSize
                }
                suppliesFlowList(para).then(res => {
                    if (res.data.status==100) {
                        this.returnData = res.data.results.list
                        this.returnData.forEach((item,index) => {
                            item.operatorTime = this.filters.formatDate(item.operatorTime)
                        })
                        this.pages.total = res.data.results.total
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //清空刷新
            refresh() {
                this.suppliesFlowList()                
            },
            //确认检索
            SubmitSearch() {
                this.suppliesFlowList()
            },
        }
    }
</script>

<style lang="scss" type="text/css" scoped>
    #materExchange{
        .headerT{margin:0 0 15px 0;}
    }
</style>



// WEBPACK FOOTER //
// materExchange.vue?03b5bf22